<template>
  <div style="height: 100%;">
    <div style=" display: grid;place-items: center;height: 100%;">
      <div v-show="this.page_progress=='ready'">
        <van-form @submit="registerUsername">
          <van-cell-group inset>
            <van-field
                v-model="myUser"
                name="name"
                label="Name"
                placeholder="Name"
                :rules="[{ required: true, message: 'Name require' }]"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button round block type="primary" native-type="submit" :disabled="!janus_ok">
              SUBMIT
            </van-button>
          </div>
        </van-form>
      </div>
      <div v-show="this.page_progress=='registered'">
        <van-form @submit="doCall">
          <van-cell-group inset>
            <van-field
                v-model="myUser"
                name="name"
                label="MyName"
                placeholder="Name"
                disabled
            />
            <van-field
                v-model="toUser"
                name="toUser"
                label="ToUser"
                placeholder="ToUser"
                :rules="[{ required: true, message: 'ToUser require' }]"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button round block type="primary" native-type="submit" :disabled="!janus_ok">
              CALL
            </van-button>
          </div>
        </van-form>
      </div>
      <div v-show="this.page_progress=='calling'" >
        <div style="display: flex; justify-content: center;">
          <audio id="remoteAudio" autoplay playsinline></audio>
          <video id="myVideo" autoplay webkit-playsinline playsinline muted="muted"
                 style="background-color: #8b8080;max-height: 30%;max-width: 45%;"/>
          <video id="remoteVideo" autoplay webkit-playsinline playsinline muted="muted"
                 style="background-color: #8b8080;margin-left:20px;max-height: 30%;max-width: 45%;"/>
        </div>
        <div style="margin-top: 20px;display: flex; justify-content: center;">
          <van-button type="primary" block @click="doHangup" style="width: 80%">Hangup</van-button>
        </div>


      </div>
    </div>
  </div>
</template>

<script>

import "vant/es/toast/style";
import Janus from "@/assets/js/janus";
import {Toast} from "vant";
import { Dialog } from "vant";

export default {
  name: "Audio",
  props: {
  },
  data() {
    return {
      // janus相关
      janus: null,
      janus_server: process.env.VUE_APP_JANUS_SERVER,
      opaqueId: "videoroomtest-" + Janus.randomString(12),
      videocall:null,
      jsep:null,

      // 状态保存
      janus_ok:false,
      page_progress:'ready',

      // 输入name
      myUser: '',
      // janus注册name
      registerUser:'',
      // 拨打对方name
      toUser:'',

      // 视频流
      stream:null,
    };
  },
  mounted() {
    // 初始化Janus
    this.initJanus();
  },
  methods: {
    doHangup(){
      // 挂断janus
      let hangup = { request: "hangup" };
      this.videocall.send({ message: hangup });
      this.videocall.hangup();
    },
    answerCall(answerJsep){
      this.videocall.createAnswer({
        jsep: answerJsep,
        tracks: [
          { type: "audio", capture: true, recv: true },
          { type: "video", capture: true, recv: true },
          { type: "data" },
        ],
        success: (jsep) => {
          Janus.debug("Got SDP!", jsep);
          var body = { request: "accept" };
          this.videocall.send({ message: body, jsep: jsep });
        },
        error: (error) => {
          Janus.error("WebRTC error:", error);
        },
      });
    },
    doCall(){
      Toast.loading({
        overlay: true,
        duration: 0,
        forbidClick: true,
      });
      this.videocall.createOffer({
        // We want bidirectional audio and video, plus data channels
        tracks: [
          { type: "audio", capture: true, recv: true },
          { type: "video", capture: true, recv: true },
          { type: "data" },
        ],
        success: (jsep) => {
          var body = { request: "call", username: this.toUser };
          this.videocall.send({ message: body, jsep: jsep });
        },
        error: (error) => {
          console.log(error);
        },
      });
    },
    registerUsername(){
      let registerName =  this.myUser;
      this.videocall.send({ message: { request: "register", username: registerName } });
    },
    initJanus(){
      let serverStunUrl='turn:43.154.16.102:3478';
      if (window.location.host.indexOf('tmp') === -1) {
        serverStunUrl='turn:35.78.136.103:3478';
      } 

      let iceServers=[{urls: serverStunUrl,username: "lqf", credential: "123456"}];

      Janus.init({
        debug: "all",
        callback: () => {
          console.log("init ok");
          if (!Janus.isWebrtcSupported()) {
            alert("No WebRTC support... ");
            return;
          }
          Janus.videoPageDestory();
          //创建session
          var localTracks = {},
              remoteTracks = {},
              remoteTracks2 = {};
          this.janus = new Janus({
            server: this.janus_server,
            iceServers: iceServers,
            success: () => {
              this.janus.attach({
                plugin: "janus.plugin.videocall",
                opaqueId: this.opaqueId,
                success: (pluginHandle) => {
                  this.videocall = pluginHandle;
                  this.janus_ok = true;
                },
                error: (error) => {
                  Janus.error("  -- Error attaching plugin...", error);
                },
                consentDialog: (on) => {
                  Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
                  if (on) {
                    // Darken screen and show hint
                  } else {
                    // Restore screen
                  }
                },
                iceState: (state) => {
                  Janus.log("ICE state changed to " + state);
                },
                mediaState: (medium, on, mid) => {
                  Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
                },
                webrtcState: (on) => {
                  Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                },
                slowLink: (uplink, lost, mid) => {
                  Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") + " packets on mid " + mid + " (" + lost + " lost packets)");
                },
                onmessage: (msg, jsep) => {
                  this.jsep = jsep;
                  Janus.debug(" ::: Got a message :::", msg);
                  var result = msg["result"];
                  if (result) {
                    console.log("get list ok");
                    if (result["list"]) {
                      console.log("进入list");
                      var list = result["list"];
                      console.log(list);
                    } else if (result["event"]) {
                      var event = result["event"];
                      if (event === "registered") {
                        console.log("进入registered");
                        //注册成功时
                        this.registerUser = this.escapeXmlTags(result["username"]);
                        // 获取已注册列表
                        this.videocall.send({ message: { request: "list" }});
                        // 改变页面
                        this.page_progress = 'registered';
                      } else if (event === "calling") {
                        console.log("进入calling");
                        // 去掉loading
                        Toast.clear();
                        // 弹出拨打
                        Dialog.alert({
                          title: 'Calling',
                          message: 'Waiting for the peer to answer...',
                          confirmButtonText:"cancel",
                        }).then(() => {
                          this.doHangup();
                        });
                      } else if (event === "incomingcall") {
                        console.log("进入incomingcall");
                        // 弹出被拨打
                        Dialog.confirm({
                          title: 'Incoming',
                          message:"Incoming call from"+result["username"],
                          confirmButtonText:"accept",
                          cancelButtonText:"cancel",
                        }).then(() => {
                          // on confirm
                          this.answerCall(jsep);
                        }).catch(() => {
                          // on cancel
                          this.doHangup();
                        });
                      } else if (event === "accepted") {
                        console.log("进入accepted");
                        // 关闭弹窗
                        Dialog.close();
                        // 进入calling页面
                        this.page_progress = 'calling';
                        if(jsep){
                          this.videocall.handleRemoteJsep({ jsep: jsep });
                        }
                      } else if (event === "update") {
                        console.log("进入update");
                      } else if (event === "hangup") {
                        console.log("hangup");
                        this.videocall.hangup();
                        // 关闭弹窗
                        Dialog.close();
                        // 退到拨打页面
                        this.page_progress = "registered";
                      } else if (event === "simulcast") {
                        console.log("进入simulcast");
                      }
                    }
                  } else {
                    // FIXME Error?
                    var error = msg["error"];
                    console.log(error);
                    // 去除loading
                    Toast.clear();
                    // 弹出error
                    Toast(error)
                    // 挂断
                    this.videocall.hangup();
                  }
                },
                onlocaltrack: (track, on) => {
                  console.log("onlocaltrack");
                  var trackId = track.id.replace(/[{}]/g, "");
                  if (!on) {
                    delete localTracks[trackId];
                    Janus.attachMediaStream(JQuery("#myVideo").get(0), null);
                    Janus.stopAllTracks(this.stream);
                    return;
                  }
                  // If we're here, a new track was added
                  var stream = localTracks[trackId];
                  if (stream) {
                    // We've been here already
                    return;
                  }
                  if (track.kind === "audio") {
                  } else {
                    stream = new MediaStream([track]);
                    localTracks[trackId] = stream;
                    this.stream = stream;
                    Janus.attachMediaStream(JQuery("#myVideo").get(0), this.stream);
                  }
                },
                onremotetrack: (track, mid, on) => {
                  console.log("onremotetrack");
                  if (!on) {
                    if (track.kind === "audio") {
                      delete remoteTracks2[mid];
                      Janus.attachMediaStream(JQuery("#remoteAudio").get(0), null);
                    } else {
                      delete remoteTracks[mid];
                      Janus.attachMediaStream(JQuery("#remoteVideo").get(0), null);
                    }
                    return;
                  }
                  var stream;
                  if (track.kind === "audio") {
                    stream = new MediaStream([track]);
                    remoteTracks2[mid] = stream;
                    Janus.attachMediaStream(JQuery("#remoteAudio").get(0), stream);
                  } else {
                    stream = new MediaStream([track]);
                    remoteTracks[mid] = stream;
                    Janus.attachMediaStream(JQuery("#remoteVideo").get(0), stream);
                  }
                },
                ondataopen: function (data) {
                  Janus.log("The DataChannel is available!");
                },
                ondata: (data) => {
                  // 收到消息
                  console.log("on data");
                  console.log(data);
                },
                oncleanup: () => {
                  Janus.log(" ::: Got a cleanup notification :::");
                },
              });
            },
            error: (error) => {
              Janus.error(error);
            },
            destroyed: function () {},
          });
        },
      });
    },
    escapeXmlTags(value) {
      if (value) {
        var escapedValue = value.replace(new RegExp("<", "g"), "&lt");
        escapedValue = escapedValue.replace(new RegExp(">", "g"), "&gt");
        return escapedValue;
      }
    },
  },
};
</script>

<style scoped>

</style>
